import React from 'react'
import { Navigate } from 'react-router-dom'
import useAuthStore from '../../stores/authStore'

/**
 * AdminGuard - Protects admin routes from non-admin users
 *
 * Redirects to dashboard if user is not an admin
 */
const AdminGuard = ({ children }) => {
  const user = useAuthStore((state) => state.user)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Not admin - redirect to dashboard with message
  if (user?.role !== 'admin') {
    console.warn('AdminGuard: Access denied - user is not admin')
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default AdminGuard
